export const platformAdminDashboard = {
  title: "AIRange Platform Admin",
  subtitle: "The control plane of the range platform, separated from exam business admin.",
  summaryOverall: "Platform status: {value}",
  summaryOnline: "Online centers: {count}",
  summaryChecks: "Checks: {count}",
  summaryIdentityPhase: "Identity phase: {value}",
  summaryAssetPhase: "Asset phase: {value}",
  summaryExecutionPhase: "Execution phase: {value}",
  summaryIdentityRemediation: "Identity remediation: {count}",
  summaryAssetRemediation: "Asset remediation: {count}",
  kpiOverall: "Platform Status",
  kpiOnline: "Online Centers",
  kpiChecks: "Checks",
  kpiIdentityRemediation: "Identity Remediation",
  kpiAssetRemediation: "Asset Remediation",
  governanceTitle: "Governance Overview",
  messages: {
    loadFailed: "Failed to load platform overview",
  },
  identityGovernanceTitle: "Identity Governance",
  assetGovernanceTitle: "Asset Governance",
  governanceWarnings: "Warnings",
  governanceCritical: "Critical",
  governanceIssueActiveCredentials: "Issue active credentials",
  governanceConfigureAccessGrants: "Configure access grants",
  governanceConfigureRoleMappings: "Configure role mappings",
  governanceObjectSpaceItems: "Object-space remediation",
  governanceReferenceItems: "Reference remediation",
  governanceConfigureSpaceGrants: "Configure space grants",
  governanceEnableSpaceGovernance: "Enable object-space governance",
  governanceNormalizeReferenceScope: "Normalize reference scope",
  openIdentity: "Open Identity",
  openAssets: "Open Assets",
  openCenters: "Open Centers",
  openOpsCenter: "Open Ops Center",
  opsCenterNotice:
    "This page only shows platform overview and entry summaries; use Ops Center for the runtime integration source of truth.",
  applicationsTitle: "Business Entries",
  centersTitle: "Platform Entries & Centers",
  openConsole: "Open Console",
} as const;
